const parseSessaoNumero = (value?: string | null): number | null => {
	if (!value?.trim()) return null;
	const parsed = Number.parseInt(value.trim(), 10);
	return Number.isNaN(parsed) ? null : parsed;
};

/**
 * Número da sessão atual com base na sessão da plataforma e nas sessões do prontuário.
 */
export const resolveDefaultSessaoNumero = (
	session?: Sessions.Session | null,
	recordSessions?: MedicalRecords.MedicalRecordSession[] | null,
): string => {
	const metadata = session?.metadata;
	if (metadata && typeof metadata === 'object' && !Array.isArray(metadata)) {
		const fromMetadata = parseSessaoNumero(
			String(
				(metadata as Record<string, unknown>).sessao_numero ??
					(metadata as Record<string, unknown>).sessaoNumero ??
					'',
			),
		);
		if (fromMetadata !== null) {
			return String(fromMetadata);
		}
	}

	const currentSessionId = session?.id;
	const sessions = recordSessions ?? [];

	if (currentSessionId) {
		const linkedSession = sessions.find(
			(recordSession) => recordSession.session_id === currentSessionId,
		);
		if (linkedSession) {
			return String(linkedSession.session_number);
		}
	}

	const highestSessionNumber = sessions.reduce<number | null>(
		(max, recordSession) => {
			if (recordSession.session_number < 1) return max;
			return max === null
				? recordSession.session_number
				: Math.max(max, recordSession.session_number);
		},
		null,
	);

	if (highestSessionNumber !== null) {
		return String(highestSessionNumber + 1);
	}

	return '1';
};
